export enum MigrationStrategy {
  DateAscending = "dateAscending",
  DateDescending = "dateDescending",
}

export const MigrationStrategyLabels: Record<MigrationStrategy, string> = {
  [MigrationStrategy.DateAscending]: "Date Ascending",
  [MigrationStrategy.DateDescending]: "Date Descending",
};
